import { useRef } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useLang } from '../utils/hooks'
import { langGlobalStats } from '../assets/langGlobalStats'

const MonthStatsChart = ({ title, options, checked, handleCumulClick }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langGlobalStats.fr : langGlobalStats.eng
  const chart = useRef(null)

  return (
    <div className="block">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title is-6  has-text-weight-semibold">{title}</h1>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <label className="checkbox">
              <input
                type="checkbox"
                checked={checked}
                onChange={handleCumulClick}
              />
              {choosenLang.cumulate}
            </label>
          </div>
        </div>
      </div>
      <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />
    </div>
  )
}

export default MonthStatsChart
